"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentNode = void 0;
const base_1 = require("./base");
const utils_1 = require("../utils");
/**
 * The `document` node is the root node of the document tree and the entry point for the parser
 *
 * @example
 * ```xml
 * <document>
 *   <topic/>
 * </document>
 * ```
 */
class DocumentNode extends base_1.AbstractBaseNode {
}
exports.DocumentNode = DocumentNode;
// TODO rename this to undefined
DocumentNode.nodeName = 'document';
DocumentNode.childTypes = (0, utils_1.stringToChildTypes)(['topic']);
DocumentNode.fields = [];
DocumentNode.isValidField = () => true;
//# sourceMappingURL=document.js.map